export default __webpack_public_path__ + "static/media/Group1497-Yono.3da30cb0.png";